"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTRAINTS_RESOLVER_ERROR_CODE = exports.CONSTRAINTS_EXTERNAL_QUERY_ERROR_CODE = exports.CONSTRAINTS_BAD_RESPONSE_CODE = exports.USER_INPUT_ERROR_CODE = exports.AUTHENTICATION_ERROR_CODE = void 0;
exports.AUTHENTICATION_ERROR_CODE = "AUTHENTICATION_ERROR";
exports.USER_INPUT_ERROR_CODE = "USER_INPUT_ERROR";
exports.CONSTRAINTS_BAD_RESPONSE_CODE = "CONSTRAINTS_BAD_RESPONSE";
exports.CONSTRAINTS_EXTERNAL_QUERY_ERROR_CODE = "CONSTRAINTS_EXTERNAL_QUERY_ERROR";
exports.CONSTRAINTS_RESOLVER_ERROR_CODE = "CONSTRAINTS_RESOLVER_ERROR";
